import { useMemo } from 'react';
import { SechubData } from './types';
import { useRepositoryOnboardingContext } from '../../context/RepositoryOnboardingContext';
import { hasService } from '../../hooks/useTdmsServicesData';

// Hook that uses shared data from RepositoryOnboarding context to avoid duplicate API calls
export const useSechubData = (
  repositoryValue: string,
): { data: SechubData | null; loading: boolean } => {
  const {
    integrationData: nebulaData,
    integrationLoading,
    tdmsServices,
    tdmsLoading,
  } = useRepositoryOnboardingContext();

  // Combine loading states - we need both nebula and TDMS data
  const loading = integrationLoading || tdmsLoading;

  const data = useMemo((): SechubData | null => {
    if (!repositoryValue || !nebulaData?.SecHub) {
      return null;
    }

    // Wait for TDMS data to load before deciding whether to show card
    if (tdmsLoading) {
      return null;
    }

    const hasCiCdService = hasService(tdmsServices, 'nebula-ci-cd');

    const provider = hasCiCdService ? 'nebula' : 'mercedes-benz';

    const secHubIntegration = nebulaData.SecHub;

    // Don't show the card if we don't have any information
    if (!secHubIntegration.projectKey && !secHubIntegration.source) {
      return null;
    }

    return {
      provider: provider, // Always nebula as requested
      projectKey: secHubIntegration.projectKey || '',
      source: secHubIntegration.source || '',
    };
  }, [repositoryValue, nebulaData, tdmsServices, tdmsLoading]);

  return { data, loading };
};
